import {
  APIService
} from '../services/index'

const initState = {
  status: null,
  textError: null
}

const pageStore = {
  state: initState,
  getters: {
    getStatus(state) {
      return state.status
    },
    getTextError(state) {
      return state.textError
    }
  },
  mutations: {
    UPDATE_TEXT_ERROR(state, payload) {
      state.textError = payload;
    },
    UPDATE_STATUS(state, payload) {
      state.status = payload;
    }
  },
  actions: {
    login(context, params) {
      // this.commit('SET_LOADER', true)
      APIService.login({
          utente: params.login,
          password: params.password
        })
        .then(function (res) {
          if (res.stato === 'success') {
            location.href = res.data.location;
          } else {
            context.commit('UPDATE_STATUS', 'ERROR')
            context.commit('UPDATE_TEXT_ERROR', res.textError);
          }
        })
        .catch(res => {
          context.commit('UPDATE_STATUS', 'ERROR')
          context.commit('UPDATE_TEXT_ERROR', res.statusText);
        })
        // .finally(res => {
        //   this.commit('SET_LOADER', false)
        // })
    },
    beforeResetPassword(context, params) {
        this.commit('SET_LOADER', true)
        return APIService.beforeResetPassword(params)
                .then(function (res) {
                    return res
                })
                .finally(res => {
                    this.commit('SET_LOADER', false)
                })
    },
    resetPassword(context, params) {
        this.commit('SET_LOADER', true)
        return APIService.resetPassword(params)
                .then(function (res) {
                    return res
                })
                .finally(res => {
                    this.commit('SET_LOADER', false)
                })
    }
  }
};

export default pageStore;


// WEBPACK FOOTER //
// ./modules/Home/views/src/stores/login.js